import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const UnnamedFavouriteLabel = styled('span', { label: 'UnnamedFavouriteLabel' })`
    align-items: center;
    border-right: none;
    display: flex;
    flex: 1 1 0%;
    justify-content: flex-start;
    padding: 1px 8px;
`;

interface TrapListItemPropsType {
    variant: DefaultComponentVariantType | null;
}

const setTrapListItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        background-color: ${theme.star.eventRow.bgColor};
    `;
};

export const TrapListItem = withConfig(theme => styled('li', { label: 'TrapListItem' })<TrapListItemPropsType>`
    ${({ variant }): SerializedStyles => setTrapListItem(variant, theme)}
    align-self: center;
    box-sizing: content-box;
    display: flex;
    font-weight: ${theme.star.fontWeight.medium};
    height: 40px;
    position: relative;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    width: 71px;
    @media ${theme.star.mediaQuery.tablet} {
        width: 68px;
    }
    a {
        width: 100%;
        flex: 0 0 100%;
    }
`);
